// extracted by mini-css-extract-plugin
module.exports = {"sectionTable":"styles_sectionTable__VnRLS","subtitle":"styles_subtitle___CwQd","description":"styles_description__fagk7"};